<template>
  <div>
    <section class="pricing-table section-padding" style="padding-top: 80px">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>Contact us</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>Venue Address</h3>
                <i class="fa fa-group"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">5 Caldwell Street Mount Gambier 5290 </li>
                <li class="mb-2">Next to Forty Winks</li>
<!--                <li class="mb-2">mount gambier</li>-->
<!--                <li class="mb-2">south australia</li>-->
                <li class="mb-2">&nbsp;</li>
                <li class="mb-2">&nbsp;</li>
                <li class="mb-2">&nbsp;</li>
              </ul>
              <!--              <a href="#" class="template-btn">Buy now</a>-->
            </div>
          </div>
<!--          <div class="col-md-4">-->
<!--            <div class="single-table text-center mb-4 mb-md-0">-->
<!--              <div class="table-top">-->
<!--                <h3>Trading Hours</h3>-->
<!--                <i class="fa fa-cutlery"></i>-->
<!--              </div>-->
<!--              <ul class="my-5">-->
<!--                <li class="mb-2">Thursday 3:00pm – 9:00pm</li>-->
<!--                <li class="mb-2">Friday 12:00pm – 10:00pm</li>-->
<!--                <li class="mb-2">Saturday 12:00pm – 10:00pm</li>-->
<!--                <li class="mb-2">Sunday 12:00pm – 8:00pm</li>-->
<!--                <li class="mb-2">&nbsp;</li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
          <div class="col-md-6">
            <div class="single-table text-center">
              <div class="table-top">
                <h3>Contact Venue</h3>
                <i class="fa fa-comment-o"></i>
              </div>
              <ul class="my-5">
<!--                <li class="mb-2">✉️ mountgambierbrewery@gmail.com</li>-->
                <li class="mb-2">📞 0466900048</li>
                <li class="mb-2">&nbsp;</li>
                <li class="mb-2">&nbsp;</li>
                <li class="mb-2">&nbsp;</li>
                <li class="mb-2">&nbsp;</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>




    <!-- Contact Form Starts -->

<!--    <section class="contact-form section-padding3">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>Get in touch</h2>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-10 offset-lg-1">-->
<!--            <el-form>-->
<!--              <div class="left">-->
<!--                <el-input v-model="name" maxlength="32" type="text" placeholder="Enter your name"/>-->
<!--                <el-input v-model="email" maxlength="128" type="email" placeholder="Enter email address"/>-->
<!--                <el-input v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)"-->
<!--                          onkeyup="this.value = this.value.replace(/[^\d]/g,'');" placeholder="Enter subject"/>-->
<!--              </div>-->
<!--              <div class="right">-->
<!--                <el-input type="textarea" maxlength="500" v-model="message" cols="20" rows="7" placeholder="Enter Message"></el-input>-->
<!--              </div>-->
<!--              <button @click="submit" class="template-btn">subscribe now</button>-->
<!--            </el-form>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- Contact Form End -->
  </div>
</template>
<script>

export default {
  data () {
    return {
      name: null,
      email: null,
      phone: null,
      message: null
    }
  },
  methods: {
    submit: function (event) {
      console.log(this.name)
      console.log(this.email)
      console.log(this.phone)
      console.log(this.message)
      if (this.name == null || this.name === '') {
        this.msgError('姓名不能为空')
        return false
      }
      if (this.name.length > 32) {
        this.msgError('姓名不能过长')
        return false
      }
      if ((this.email == null || this.email === '') && (this.phone == null || this.phone === '')) {
        this.msgError('邮箱和手机号，至少填写一个')
        return false
      }
      if (this.email != null && this.email !== '') {
        if (!/^(\w)+(.?\w*)*@[\da-z.-]+.([a-z]{2,6}|[\u2E80-\u9FFF]{2,3})$/.test(this.email)) {
          this.msgError('邮箱格式有误')
          return false
        }
      }
      if (this.phone != null && this.phone !== '') {
        if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phone)) {
          this.msgError('手机号格式有误')
          return false
        }
      }
      if (this.message == null || this.message === '') {
        this.msgError('详细信息不能为空')
        return false
      }
      if (this.message.length > 500) {
        this.msgError('详细信息不能过长')
        return false
      }
      this.$http({
        method: 'POST',
        // url: 'https://selfapi.bjdianxing.com/app/person/menhuData',
        url: 'https://localhost:8084/app/person/menhuData',
        data: {'name': this.name, 'email': this.email, 'phone': this.phone, 'message': this.message},
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      }).then((res) => {
        this.msgSuccess('提交成功')
        this.name = null
        this.email = null
        this.phone = null
        this.message = null
      }).catch((err) => {
        console.log(err)
        this.msgError('提交失败,请稍后重试')
      })
      // submitMenhu(this.form).then(response => {
      //   this.msgSuccess('提交成功')
      //   this.name = null
      //   this.email = null
      //   this.phone = null
      //   this.message = null
      // })
    }
  }
}
</script>




// WEBPACK FOOTER //
// ContactUs.vue?dcfe4e0a